import { TRawServiceApiKeys } from "@/interfaces";

const API_FLAG_ALIAS_MAP: Partial<
  Record<string, keyof typeof TRawServiceApiKeys>
> = {
  internal_credit_score: "Bank_Validation",
  returned_check_details: "Bounced_Check",
};

export function getClientServiceKeyByAPIFlag(
  flag: string,
): keyof typeof TRawServiceApiKeys | undefined {
  if (API_FLAG_ALIAS_MAP[flag]) return API_FLAG_ALIAS_MAP[flag];

  return Object.keys(TRawServiceApiKeys).find(
    (key) =>
      TRawServiceApiKeys[key as keyof typeof TRawServiceApiKeys] === flag,
  ) as keyof typeof TRawServiceApiKeys | undefined;
}
